/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import requestConnector from './requestConnector';
import ErrorBoundary from './ErrorBoundary';
import reduxConnector from "./reduxConnector";

export default requestConnector(reduxConnector(ErrorBoundary));
